import './page/components/BrandingPage/index';
import { InitBrandingPage } from './page/components/BrandingPage/index';

window.addEventListener('DOMContentLoaded', () => {
  InitBrandingPage();
});
